import {
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';
import useAppUser from 'hooks/useAppUser';
import useAgencySettingsAccessUrl from 'hooks/integrations/useAgencySettingsAccessUrl';

const useHostfullyAccounting = () => {
  const { isEmployeeManager } = useAppUser();
  const {
    integration,
    agencySettings,
    isLoading,
    isFetching,
    fetchAccessUrl: fetchAccountingAccess,
  } = useAgencySettingsAccessUrl({
    enumId: IntegrationEnum.HOSTFULLYACCOUNTING,
    enabled: isEmployeeManager,
  });

  // Flag, role, and agency country checks are owned by the BE; the FE only
  // honors the status returned for the integration. Fetch errors leave the
  // payload undefined and resolve as ineligible.
  const isAccountingEligible = Boolean(
    integration &&
      agencySettings &&
      agencySettings.status !== IntegrationStatus.NOT_SUPPORTED,
  );

  const isAccountingActive =
    agencySettings?.status === IntegrationStatus.ACTIVE;

  return {
    isAccountingEligible,
    isAccountingActive,
    isLoading,
    isFetching,
    fetchAccountingAccess,
  };
};

export default useHostfullyAccounting;
